import { Component, HostListener, OnInit } from '@angular/core';
import { ParameterDto } from '@app/@core/api/models';
import { ParameterByDomainService } from '@app/@core/services';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-additional',
  templateUrl: './additional.component.html',
  styleUrls: ['./additional.component.scss'],
})
export class AdditionalComponent implements OnInit {
  public parameters$: Observable<ParameterDto>;
  public phone: string;
  public backgroundImageUrl: string = '';
  private backgroundImages: any = {
    es: {
      mobile:
        'https://res.cloudinary.com/pervolare-org/image/upload/v1731471013/spv/sites/images/Additional/banner-additional-mobile_knvanc.png',
      web: 'https://res.cloudinary.com/pervolare-org/image/upload/v1739919283/spv/sites/images/Additional/Banner_Servicios_Adicionales_gqdakx.webp',
    },
    en: {
      mobile:
        'https://res.cloudinary.com/pervolare-org/image/upload/v1750394297/spv/sites/images/Additional/Screenshot_4_sh2spo.jpg',
      web: 'https://res.cloudinary.com/pervolare-org/image/upload/v1750392824/spv/sites/images/Additional/Screenshot_2_skydgw.jpg',
    },
    pt: {
      mobile:
        'https://res.cloudinary.com/pervolare-org/image/upload/v1750394457/spv/sites/images/Additional/Screenshot_5_jpf6m3.jpg',
      web: 'https://res.cloudinary.com/pervolare-org/image/upload/v1750393174/spv/sites/images/Additional/Screenshot_3_rlky1w.jpg',
    },
  };

  constructor(
    private readonly _parameterDomain: ParameterByDomainService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this._parameterDomain.parameter$.subscribe((params) => {
      this.phone = params.addresses.whatsapp.replace(/\s+/g, '');
    });

    // Establece la imagen de fondo inicial
    this.updateBackgroundImage();

    this.translate.onLangChange.subscribe(() => {
      this.updateBackgroundImage();
    });
  }

  // Escucha cambios en el tamaño de la ventana para adaptar el fondo a móvil/web
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateBackgroundImage();
  }

  private updateBackgroundImage(): void {
    const lang = localStorage.getItem('language') || this.translate.currentLang || 'es';
    const isMobile = window.innerWidth < 768;

    const deviceType = isMobile ? 'mobile' : 'web';

    if (this.backgroundImages[lang] && this.backgroundImages[lang][deviceType]) {
      this.backgroundImageUrl = this.backgroundImages[lang][deviceType];
    } else {
      this.backgroundImageUrl = this.backgroundImages['es']['web'];
      console.warn(`No background image found for language: ${lang} and device: ${deviceType}. Using default.`);
    }
  }
}
